
/**
 * Specifies when the loading indicators should be visible on charts
 */
export enum ChartLoadingOptionsEnum {
    /** Never show the loading indicator */
    none,

    /** Show the loading indicator until any series has data */
    any,

    /** Show the loading indicator until all series have data */
    all
}
